<template>
  <div class="overlay">
    <div class="role-switcher pa-2">
      <v-switch hide-details v-model="isRoleSwitchActive" label="Frontend Role Switcher" small/>
    </div>
    <v-divider/>
    <div class="current-roles-overview pa-2">
      <p class="mb-0"><span style="font-weight: bold">Admin: </span>{{isAdmin}}</p>
      <p class="mb-0"><span style="font-weight: bold">School admin: </span>{{isSchoolAdmin}}</p>
      <h4>Current Roles:</h4>
      <ul>
        <li v-for="(ideaSpaces, name) in assignedRoles">
          {{ name }} <span v-if="ideaSpaces[0] != null">in {{ getNameOfIdeaSpace(ideaSpaces[0]) }}</span>
          <v-icon v-if="isRoleSwitchActive" small @click="removeRole(name)">delete</v-icon>
        </li>
      </ul>
    </div>
    <v-divider/>
    <div v-if="isRoleSwitchActive" class="role-selector pa-2">
      <h4>Assign new Role</h4>
      <v-select
        v-model="selectedRoleId"
        :items="roles"
        item-text="name"
        item-value="id"
        label="Role"/>
      <v-select
        v-model="selectedIdeaSpaceId"
        :items="ideaSpaces"
        label="Idea Space"/>
      <v-btn :disabled="selectedRoleId === null" @click="addRole" color="primary">Assign</v-btn>
    </div>
  </div>
</template>

<script>
import {getIdeaSpaces} from '../utils/ideaSpaces'
import _ from 'lodash'
import {getUserRoles} from '../utils/userRoles'

export default {
  name: 'RoleSwitcher',
  data: function () {
    return {
      roles: null,
      ideaSpaces: null,
      selectedRoleId: null,
      selectedIdeaSpaceId: null
    }
  },
  beforeMount: async function () {
    this.roles = await getUserRoles()
    this.ideaSpaces = await getIdeaSpaces(this.$store.getters.selected_school, this.$vuetify.t)
  },
  computed: {
    assignedRoles: {
      get () {
        return this.$store.getters.roles
      }
    },
    isAdmin: {
      get () {
        return this.$store.getters.isAdmin
      }
    },
    isSchoolAdmin: {
      get () {
        return this.$store.getters.isSchoolAdmin
      }
    },
    assignedPermissions: {
      get () {
        return this.$store.getters.permissions
      }
    },
    isRoleSwitchActive: {
      get () {
        return this.$store.getters.isRoleSwitchActive
      },
      set (value) {
        this.$router.go(0)
        this.$store.commit('SET_ROLE_SWITCHER', value)
      }
    }
  },
  methods: {
    addRole: function () {
      let selectedRole = this.roles.find(role => role.id === this.selectedRoleId)
      let extendedAssignedRoles = _.assign(this.assignedRoles, {[selectedRole.name]: [this.selectedIdeaSpaceId]})
      let extendedAssignedPermissions = _.assign(this.assignedPermissions, {[selectedRole.name]: selectedRole.permissions})
      this.$store.commit('SET_ROLE', extendedAssignedRoles)
      this.$store.commit('SET_PERMISSIONS', extendedAssignedPermissions)
      this.$router.go(0)
    },
    removeRole: function (role) {
      let reducedAssignedRoles = _.omit(this.assignedRoles, role)
      let reducedAssignedPermissions = _.omit(this.assignedPermissions, role)
      this.$store.commit('SET_ROLE', reducedAssignedRoles)
      this.$store.commit('SET_PERMISSIONS', reducedAssignedPermissions)
      this.$router.go(0)
    },
    getNameOfIdeaSpace: function (ideaSpaceId) {
      if (this.ideaSpaces) {
        return this.ideaSpaces.find(ideaSpace => ideaSpace.value === ideaSpaceId).text
      }
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  background-color: white;
  width: 250px;
  height: auto;
  bottom: 0;
  right: 0;
  z-index: 1000;
  margin: 50px;
  border-radius: 1rem;
}

.v-input--selection-controls {
  margin-top: 0 !important;
}
</style>
